const breaktimeSchema={
    feilds:[{
        id: 1,
        name: 'break_reason_dropdown',
        text: 'Reason Dropdown',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Reason Dropdown',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Reason Dropdown'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    }

    ]
}


export { breaktimeSchema };